import { styled } from '@mui/material';
import { TOGGLE } from '../toggleConstants.js';

const PADDING = TOGGLE.thumbSize / 2 - TOGGLE.trackHeight / 2 - TOGGLE.thumbOffset;
const ToggleRoot = styled("span")(({ theme }) => ({
    display: "inline-block",
    position: "relative",
    width: TOGGLE.trackWidth,
    borderRadius: TOGGLE.radius,
    padding: `${PADDING}px`,
    backgroundColor: "initial",
    border: "none",
    "&:focus-within": {
        outline: `2px solid ${theme.palette.primary[400]}`,
        outlineOffset: 1,
    },
}));

export { ToggleRoot };
//# sourceMappingURL=ToggleRoot.js.map
